import { render, staticRenderFns } from "./ServicesTableActions.vue?vue&type=template&id=51716776&scoped=true&"
import script from "./ServicesTableActions.vue?vue&type=script&lang=js&"
export * from "./ServicesTableActions.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTableActions.vue?vue&type=style&index=0&id=51716776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51716776",
  null
  
)

export default component.exports